import { render, staticRenderFns } from "./turnStudentList.vue?vue&type=template&id=130b97e2&"
import script from "./turnStudentList.vue?vue&type=script&lang=js&"
export * from "./turnStudentList.vue?vue&type=script&lang=js&"
import style0 from "./turnStudentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports